export default "__VITE_ASSET__BTanBMoP__"